export default "__VITE_ASSET__1qthAATFqLq4toQxxIy80Q__";